<template>
  <input-select
    v-model="proxyValue"
    v-bind="$attrs"
    :items="states"
    v-on="$listeners"
    @blur="emitInput()"
  />
</template>

<script>
import UF from 'Arch/enums/UF';

export default {
  name: 'InputState',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    states: UF,
    proxyValue: '',
  }),
  computed: {
    getValue() {
      return this.value;
    },
    emitInput() {
      return () => {
        this.$emit('input', this.proxyValue);
      };
    },
  },
  watch: {
    getValue: {
      immediate: true,
      handler(value) {
        if (value) {
          this.proxyValue = value;
        }
      },
    },
  },
};
</script>
